import styled from 'styled-components';

import { TITLE_BAR_HEIGHT, resetTitleBarOffset } from 'common/styles/titleBar';
import FlexContainer from './FlexContainer';

// v2 is a page-level modal that sits below the title bar, so it starts at the bar's real
// height and keeps the bar's offset for the layouts inside it. The original modal covers
// the whole viewport, bar included, so the layouts inside it ignore the bar.
const Background = styled(FlexContainer)`
  position: fixed;
  top: ${props => props.version === 'v2' ? TITLE_BAR_HEIGHT : '0'};
  ${props => props.version === 'v2' ? '' : resetTitleBarOffset}
  left: 0;
  z-index: 999;
  height: 100%;
  width: 100%;
  background: ${props => (props.fullScreen ? 'white' : 'rgba(56,56,56,0.96)')};
`;

Background.displayName = 'Background';

export default styled(Background)``;
